// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__ccGwH","ContactSectionDiv":"Contact_ContactSectionDiv__CAg+2","ContactSection":"Contact_ContactSection__vA3z+"};